/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Backup_Restart_NoticeInputs */



/**
* | output |
* | --- |
* | "Please restart the application for changes to take effect." |
*
* @param {Options_Backup_Restart_NoticeInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_backup_restart_notice = /** @type {((inputs?: Options_Backup_Restart_NoticeInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Backup_Restart_NoticeInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Veuillez redémarrer l'application pour que les changements prennent effet.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Bitte starten Sie die Anwendung neu, damit die Änderungen wirksam werden.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Riavviare l'applicazione affinché le modifiche abbiano effetto.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Для вступления изменений в силу, пожалуйста, перезапустите приложение.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Reinicie la aplicación para que los cambios surtan efecto.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("请重启应用程序以使更改生效。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("変更を有効にするには、アプリケーションを再起動してください。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("परिवर्तनों को प्रभावी होने के लिए कृपया एप्लिकेशन को पुनः आरंभ करें।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Reinicie o aplicativo para que as alterações entrem em vigor.")
	return /** @type {LocalizedString} */ ("Please restart the application for changes to take effect.")
});